import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState } from 'react';
import { Button, Form, Loader, Message, Checkbox } from 'semantic-ui-react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { CARD_ELEMENT_STYLE, SUBMIT_BUTTON_DEFAULT_TEXT } from './StripePaymentSourceForm.constants';
import { createStripePaymentMethod, createStripeToken } from './StripePaymentSourceForm.utils';
import './StripePaymentSourceForm.css';
var defaultProps = {
  showPostalCode: true,
  showSubmitButton: true,
  submitButtonText: SUBMIT_BUTTON_DEFAULT_TEXT,
  onSubmit: null,
  isGuestUser: false,
  onPaymentMethodCreated: function onPaymentMethodCreated() {
    return null;
  },
  onTokenCreated: function onTokenCreated() {
    return null;
  },
  disabled: false
};
export default function StripePaymentSourceForm(_ref) {
  var showPostalCode = _ref.showPostalCode,
    showSubmitButton = _ref.showSubmitButton,
    submitButtonText = _ref.submitButtonText,
    onSubmit = _ref.onSubmit,
    isGuestUser = _ref.isGuestUser,
    onPaymentMethodCreated = _ref.onPaymentMethodCreated,
    onTokenCreated = _ref.onTokenCreated,
    disabledProp = _ref.disabled;
  // in order to use this component, it must have a Stripe <Elements> parent

  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cardFormComplete = _useState4[0],
    setCardFormComplete = _useState4[1];
  var _useState5 = useState({
      inputErrorMessage: '',
      errorMessage: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState({
      postalCode: '',
      nameOnCard: '',
      savePaymentSource: false
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    formFields = _useState8[0],
    setFormFields = _useState8[1];
  var stripe = useStripe();
  var elements = useElements();
  if (!stripe || !elements) {
    return /*#__PURE__*/React.createElement(Loader, {
      active: true,
      inline: "centered"
    });
  }
  var postalCode = formFields.postalCode,
    nameOnCard = formFields.nameOnCard,
    savePaymentSource = formFields.savePaymentSource;
  var inputErrorMessage = errors.inputErrorMessage,
    errorMessage = errors.errorMessage;
  var options = {
    hidePostalCode: !showPostalCode,
    style: CARD_ELEMENT_STYLE
  };
  var cardElement = elements.getElement(CardElement);
  var disabled = !!inputErrorMessage || !cardFormComplete || !nameOnCard || loading;
  function clearError() {
    setErrors(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, {
        errorMessage: ''
      });
    });
  }
  function createPaymentMethod() {
    return _createPaymentMethod.apply(this, arguments);
  }
  function _createPaymentMethod() {
    _createPaymentMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var payload, response, _response$paymentMeth, providerId, _response$paymentMeth2, _response$paymentMeth3, last4, brand, type, card;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            payload = {
              nameOnCard: nameOnCard,
              postalCode: postalCode
            };
            _context.next = 3;
            return createStripePaymentMethod(stripe, cardElement, payload);
          case 3:
            response = _context.sent;
            _response$paymentMeth = response.paymentMethod, providerId = _response$paymentMeth.id, _response$paymentMeth2 = _response$paymentMeth.card, _response$paymentMeth3 = _response$paymentMeth2 === void 0 ? {} : _response$paymentMeth2, last4 = _response$paymentMeth3.last4, brand = _response$paymentMeth3.brand, type = _response$paymentMeth.type;
            card = {
              last4: last4,
              brand: brand
            };
            _context.next = 8;
            return onPaymentMethodCreated({
              providerId: providerId,
              savePaymentSource: savePaymentSource,
              card: card,
              type: type
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _createPaymentMethod.apply(this, arguments);
  }
  function createToken() {
    return _createToken.apply(this, arguments);
  }
  function _createToken() {
    _createToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload, response, _response$token, tokenId, _response$token$card, _response$token$card2, last4, brand, type, card;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            payload = {
              nameOnCard: nameOnCard,
              postalCode: postalCode
            };
            _context2.next = 3;
            return createStripeToken(stripe, cardElement, payload);
          case 3:
            response = _context2.sent;
            _response$token = response.token, tokenId = _response$token.id, _response$token$card = _response$token.card, _response$token$card2 = _response$token$card === void 0 ? {} : _response$token$card, last4 = _response$token$card2.last4, brand = _response$token$card2.brand, type = _response$token.type;
            card = {
              last4: last4,
              brand: brand
            };
            _context2.next = 8;
            return onTokenCreated({
              tokenId: tokenId,
              savePaymentSource: savePaymentSource,
              card: card,
              type: type
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _createToken.apply(this, arguments);
  }
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
      var message;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();
            if (!disabled) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return");
          case 3:
            _context3.prev = 3;
            clearError();
            setLoading(true);
            if (!onSubmit) {
              _context3.next = 11;
              break;
            }
            _context3.next = 9;
            return onSubmit({
              cardElement: cardElement,
              nameOnCard: nameOnCard,
              postalCode: postalCode,
              savePaymentSource: savePaymentSource
            });
          case 9:
            _context3.next = 18;
            break;
          case 11:
            if (!(!isGuestUser && savePaymentSource)) {
              _context3.next = 16;
              break;
            }
            _context3.next = 14;
            return createPaymentMethod();
          case 14:
            _context3.next = 18;
            break;
          case 16:
            _context3.next = 18;
            return createToken();
          case 18:
            setLoading(false);
            _context3.next = 26;
            break;
          case 21:
            _context3.prev = 21;
            _context3.t0 = _context3["catch"](3);
            message = _context3.t0.displayableMessage || 'An error ocurred';
            setErrors(function (previousState) {
              return _objectSpread(_objectSpread({}, previousState), {}, {
                errorMessage: message
              });
            });
            setLoading(false);
          case 26:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 21]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function onChange(event) {
    var e = event.error,
      complete = event.complete,
      value = event.value;
    var inputPostalCode = value.postalCode;
    if (cardFormComplete !== complete) {
      setCardFormComplete(complete);
    }
    if (postalCode !== inputPostalCode) {
      setFormFields(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          postalCode: inputPostalCode
        });
      });
    }
    if (e) {
      setErrors(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          inputErrorMessage: e.message
        });
      });
    } else {
      setErrors(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          inputErrorMessage: ''
        });
      });
    }
  }
  function onNameOnCardChange(event, _ref2) {
    var value = _ref2.value;
    setFormFields(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, {
        nameOnCard: value
      });
    });
  }
  function onSavePaymentSourceChange(event, _ref3) {
    var checked = _ref3.checked;
    setFormFields(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, {
        savePaymentSource: checked
      });
    });
  }
  return /*#__PURE__*/React.createElement(Form, {
    className: "stripe-payment-source-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Input, {
    required: true,
    label: "Name On Card",
    placeholder: "Cardholder's Name",
    type: "text",
    onChange: onNameOnCardChange,
    value: nameOnCard,
    name: "nameOnCard",
    width: 8
  }), /*#__PURE__*/React.createElement(Form.Input, {
    required: true,
    label: "Card Details",
    width: 10
  }, /*#__PURE__*/React.createElement(CardElement, {
    options: options,
    onChange: onChange
  }))), inputErrorMessage && /*#__PURE__*/React.createElement("p", {
    className: "input-error-message"
  }, inputErrorMessage), /*#__PURE__*/React.createElement(Message, {
    error: true,
    content: errorMessage,
    visible: !!errorMessage,
    onDismiss: clearError
  }), !isGuestUser && /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onSavePaymentSourceChange,
    checked: savePaymentSource,
    label: "Save this payment method"
  }), showSubmitButton && /*#__PURE__*/React.createElement("div", {
    className: "submit-button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    content: submitButtonText,
    type: "submit",
    disabled: disabled || disabledProp,
    loading: loading
  })));
}
StripePaymentSourceForm.defaultProps = defaultProps;